module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    staticClass: "target-probes__layout__content",
    staticStyle: {},
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pl-3 pb-0 pt-3",
    staticStyle: {
      "border-bottom": "2px solid #455A64",
      "background-color": "rgba(0,0,0,.02)"
    },
    attrs: {
      "lg12": "",
      "xs12": ""
    }
  }, [_c('h4', [_vm._v("Scores")])]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "background": "white"
    },
    attrs: {
      "md5": "",
      "lg6": "",
      "xs12": ""
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "550px",
      "padding-top": "15px"
    },
    attrs: {
      "id": "container"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('table', {
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "background-color": "rgba(27, 73, 101, 1)",
      "border-radius": "5px",
      "width": "20px",
      "height": "20px"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "pl-2"
  }, [_c('span', [_vm._v("Also in chemicalprobes.org")])])])])])]), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-2",
    attrs: {
      "md7": "",
      "lg6": "",
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs2": ""
    }
  }, [_c('button', {
    staticClass: "prev"
  }, [_c('v-btn', {
    staticClass: "teal lighten-2",
    attrs: {
      "fab": "",
      "dark": "",
      "small": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("keyboard_arrow_left")])], 1)], 1)]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center elevation-0 pa-0",
    attrs: {
      "xs8": ""
    }
  }, [(_vm.counter < _vm.sorted20.length) ? _c('v-progress-linear', {
    attrs: {
      "color-front": "teal lighten-1",
      "color-back": "blue-grey",
      "height": "15"
    },
    model: {
      value: (_vm.counterPrc),
      callback: function($$v) {
        _vm.counterPrc = $$v
      },
      expression: "counterPrc"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.counter < _vm.sorted20.length) ? _c('div', {
    staticStyle: {
      "width": "100",
      "text-align": "right"
    }
  }, [_vm._v(_vm._s(_vm.counter) + " / " + _vm._s(_vm.sorted20.length))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "siema white",
    class: {
      withOpacity: !_vm.doneloading, withoutOpacity: _vm.doneloading
    }
  }, _vm._l((_vm.sorted20), function(m, index) {
    return _c('v-card', {
      key: index,
      staticClass: "mb-2",
      staticStyle: {
        "border": "1px solid rgba(0,0,0,.1)"
      },
      attrs: {
        "hover": "",
        "flat": ""
      }
    }, [_c('v-card-title', {
      staticClass: "teal lighten-2 white--text"
    }, [_c('h3', {
      staticClass: "headline mb-0 white--text"
    }, [_vm._v(_vm._s(m.namec))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
      staticClass: "teal darken-1 white--text",
      nativeOn: {
        "click": function($event) {
          _vm.redirectToCompound(m.idc)
        }
      }
    }, [_c('v-icon', {
      staticClass: "white--text"
    }, [_vm._v("navigate_next")]), _vm._v("SHOW MORE\n              ")], 1)], 1), _vm._v(" "), (m['chemical_probes_portal']) ? _c('v-card-title', {
      staticClass: "teal lighten-2 white--text",
      staticStyle: {
        "width": "100%"
      }
    }, [_c('a', {
      staticStyle: {
        "text-decoration": "none",
        "width": "100%"
      },
      attrs: {
        "target": "_blank",
        "href": 'http://www.chemicalprobes.org/' + m.chemical_probes_portal.name
      }
    }, [_c('v-card', {
      staticClass: "teal darken-1 white--text",
      staticStyle: {
        "padding": "10px 10px 2px 10px"
      },
      attrs: {
        "row": "",
        "wrap": "",
        "hover": "",
        "align-center": ""
      }
    }, [_c('img', {
      attrs: {
        "height": "40",
        "src": "http://www.chemicalprobes.org/sites/all/themes/zurb_foundation/images/cp-img/chemical-probes-logo@2x.png"
      }
    }), _vm._v(" "), _c('v-flex', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "xs12": ""
      }
    }, [_c('star-rating', {
      staticStyle: {
        "margin": "0 auto",
        "width": "88px !important"
      },
      attrs: {
        "max-rating": 4,
        "increment": 0.01,
        "rating": Math.round(parseFloat(m['chemical_probes_portal']['rating_cell'])),
        "star-size": 20,
        "show-rating": false,
        "read-only": true,
        "inactive-color": "black",
        "active-color": "#ffffff"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('span', {
      staticClass: "white--text"
    }, [_vm._v("Go to The Chemical Probes Portal page for this compound")])])], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('v-card-text', {
      staticClass: "pa-0",
      on: {
        "click": function($event) {
          _vm.redirectToCompound(m.idc)
        }
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "align-center": ""
      }
    }, [_c('v-flex', {
      staticClass: "text-xs-center teal darken-1 white--text pa-3",
      attrs: {
        "xs6": ""
      }
    }, [_vm._v("Compound")]), _vm._v(" "), _c('v-flex', {
      staticClass: "text-xs-center teal darken-2 white--text pa-3",
      attrs: {
        "xs6": ""
      }
    }, [_vm._v("\n                  Values\n                  "), _c('v-icon', {
      staticClass: "white--text",
      staticStyle: {
        "font-size": "14px"
      },
      attrs: {
        "id": "radar-tooltip",
        "dark": ""
      }
    }, [_vm._v("info")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "none",
        "text-align": "left"
      },
      attrs: {
        "id": "radar-details"
      }
    }, [_c('table', {
      staticStyle: {
        "text-align": "left !important"
      }
    }, [_c('tr', [_c('td', [_c('span', {
      staticClass: "body-2"
    }, [_vm._v("PAINS")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1: The compound is not predicted to be a Pan-Assay Interference Compound.")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("0: The compound is predicted to be a Pan-Assay Interference Compound")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
      staticClass: "body-2"
    }, [_vm._v("CELL POTENCY")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1: The compound is active below 10 uM in at least one cell line.")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("0: The compound is no active below 10 uM in any cell line")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
      staticClass: "body-2"
    }, [_vm._v("SAR")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1: The compound has active analogs")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("0: We do not identify analogs of the compound")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
      staticClass: "body-2"
    }, [_vm._v("INACTIVE ANALOGS")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("1: The compound has inactive analogs")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("0: We do not identify inactive analogs of the compound")])])]), _vm._v(" "), _c('p', [_vm._v("POTENCY AND SELECTIVITY are continues measures of potency and selectivity from 0 (no selectivity) to 1. ")]), _vm._v(" "), _c('p', [_vm._v("Please see methods for details.")])])], 1), _vm._v(" "), _c('v-flex', {
      staticClass: "text-xs-right pa-2",
      attrs: {
        "xs11": "",
        "md10": "",
        "lg10": ""
      }
    }), _vm._v(" "), (!m['is_selectivity']) ? _c('v-flex', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip:left",
        value: ({
          html: 'Chemical Tool less tha 10-fold selective'
        }),
        expression: "{ html: 'Chemical Tool less tha 10-fold selective' }",
        arg: "left"
      }],
      staticClass: "text-xs-right pa-2",
      attrs: {
        "xs1": "",
        "md2": "",
        "lg2": ""
      }
    }, [_c('v-icon', {
      staticClass: "red--text pr-2",
      staticStyle: {
        "font-size": "35px"
      }
    }, [_vm._v("report_problem")])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "align-center": ""
      }
    }, [_c('v-flex', {
      staticClass: "text-xs-center",
      attrs: {
        "xs6": ""
      }
    }, [_c('div', [_c('img', {
      staticClass: "image-carousel",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": _vm.apiUrl + 'shared/ajax/get_compound_image.php?compound_id=' + m.idc
      }
    })])]), _vm._v(" "), _c('v-flex', {
      staticClass: "text-xs-center",
      attrs: {
        "xs6": ""
      }
    }, [_c('div', {
      staticClass: "target-probes__layout__content__spider__layout"
    }, [_c('div', {
      staticStyle: {
        "height": "160px",
        "width": "100%",
        "margin": "0 auto"
      },
      attrs: {
        "id": 'spider-' + index
      }
    })])])], 1), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "100%"
      }
    }, [_c('table', {
      staticClass: "card-table"
    }, [_c('tr', [_c('td', {
      staticClass: "carousel-table-title"
    }, [_vm._v("Global Score")]), _vm._v(" "), _c('td', {
      staticClass: "carousel-table-value"
    }, [_vm._v(_vm._s(Math.round(m.global * 100) / 100))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "carousel-table-title"
    }, [_vm._v("Rank")]), _vm._v(" "), _c('td', {
      staticClass: "carousel-table-value"
    }, [_vm._v(_vm._s(m.global_rank_text))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "carousel-table-title"
    }, [_vm._v("Molecular Weight")]), _vm._v(" "), _c('td', {
      staticClass: "carousel-table-value"
    }, [_vm._v(_vm._s(m.molecular_weight))])])])])], 1)], 1)
  }))], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs2": ""
    }
  }, [_c('button', {
    staticClass: "next"
  }, [_c('v-btn', {
    staticClass: "teal lighten-2",
    attrs: {
      "fab": "",
      "dark": "",
      "small": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("keyboard_arrow_right")])], 1)], 1)])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "border-bottom": "2px solid #455A64",
      "background-color": "rgba(0,0,0,.02)"
    },
    attrs: {
      "lg12": "",
      "xs12": ""
    }
  }, [_c('h4', {
    staticClass: "pl-3 pb-0 pt-3"
  }, [_vm._v("Distribution")])]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "background": "white"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "pt-3",
    staticStyle: {
      "width": "100%",
      "height": "300px"
    },
    attrs: {
      "id": "distribution-chart"
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d5145c6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/prb-target/prb-target-compounds/PrbTargetCompounds.vue
// module id = 551
// module chunks = 1